import { NavLink } from "react-router-dom";
import React from "react";

type CustomNavLinkProps = {
  text: string;
  link: string;
  saveOnClick: (e: any, link: string) => void;
};
export const CustomNavLink = ({
  text,
  link,
  saveOnClick,
}: CustomNavLinkProps) => {
  return (
    <NavLink
      className=" sm:text-xs md:text-sm lg:text-lg hover:text-sk-navbar-text-active hover:bg-sk-button-selected m-2 p-2"
      to={link}
      onClick={(e) => saveOnClick(e, link)}
      activeClassName="bg-sk-button-selected text-sk-navbar-text-active text-shadow-active"
    >
      {text}{" "}
    </NavLink>
  );
};
